import React from "react";
import { Link } from "react-router-dom";
import icon1 from "./../../images/home_icon/Popular Jobs/senior-accountant.png";
import icon2 from "./../../images/home_icon/Popular Jobs/finance-manager.png";
import icon3 from "./../../images/home_icon/Popular Jobs/financial-analyst.png";
import icon4 from "./../../images/home_icon/Popular Jobs/tax-manager.png";
import icon5 from "./../../images/home_icon/Popular Jobs/net-developer.png";
import icon6 from "./../../images/home_icon/Popular Jobs/python-developer.png";
import icon7 from "./../../images/home_icon/Popular Jobs/devops-engineer.png";
import icon8 from "./../../images/home_icon/Popular Jobs/sr-angular-developer.png";
function PopularJobsHome() {
  let userType = localStorage.getItem("user_job_type");
  let jobUrl = "";
  if (userType) {
    if (userType == "permanentrequirement") {
      jobUrl = "/applied-jobs";
    } else {
      jobUrl = "/dashboard";
    }
  } else {
    jobUrl = "/login";
  }
  return (
    <div className="row sp20">
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="icon-bx-wraper navyblue">
          <div className="icon-content">
            <div className="icon-md text-primary m-b20">
              <img alt="Senior Accountant Icon" src={icon1} />
            </div>
            <a href={jobUrl} className="dez-tilte">
              Senior Accountant{" "}
            </a>
            <p className="m-a0">18 Jobs</p>
            {/* <div className="rotate-icon"><i className="ti-location-pin"></i></div>  */}
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="icon-bx-wraper green">
          <div className="icon-content">
            <div className="icon-md text-primary m-b20">
              {/* <i className="ti-wand"></i> */}
              <img alt="Finance Manager Icon" src={icon2} />
            </div>
            <a href={jobUrl} className="dez-tilte">
              Finance Manager{" "}
            </a>
            <p className="m-a0">13 Jobs</p>
            {/* <div className="rotate-icon"><i className="ti-wand"></i></div>  */}
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="icon-bx-wraper orange">
          <div className="icon-content ">
            <div className="icon-md text-primary m-b20">
              {/* <i className="ti-wallet"></i> */}
              <img alt="Financial Analyst Icon" src={icon3} />
            </div>
            <a href={jobUrl} className="dez-tilte">
              Financial Analyst{" "}
            </a>
            <p className="m-a0">9 Jobs</p>
            {/* <div className="rotate-icon"><i className="ti-wallet"></i></div>  */}
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="icon-bx-wraper yellow">
          <div className="icon-content ">
            <div className="icon-md text-primary m-b20">
              {/* <i className="ti-cloud-up"></i> */}
              <img alt="Tax Manager Icon" src={icon4} />
            </div>
            <a href={jobUrl} className="dez-tilte">
              Tax Manager{" "}
            </a>
            <p className="m-a0">17 Jobs</p>
            {/*<div className="rotate-icon"><i className="ti-cloud-up"></i></div> */}
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="icon-bx-wraper red">
          <div className="icon-content ">
            <div className="icon-md text-primary m-b20">
              {/* <i class="fa fa-archive" style={{fontSize: "30px"}} aria-hidden="true"></i> */}

              <img alt=".Net Developer Icon" src={icon5} />
            </div>
            <a href={jobUrl} className="dez-tilte">
              .Net Developer{" "}
            </a>
            <p className="m-a0">8 Jobs</p>
            {/* <div className="rotate-icon"><i className="ti-bar-chart"></i></div>  */}
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="icon-bx-wraper pink">
          <div className="icon-content ">
            <div className="icon-md text-primary m-b20 ">
              {/* <i className="ti-tablet"></i> */}
              <img alt="Python Developer Icon" src={icon6} />
            </div>
            <a href={jobUrl} className="dez-tilte">
              Python Developer
            </a>
            <p className="m-a0">21 Jobs</p>
            {/* <div className="rotate-icon"><i className="ti-tablet"></i></div>  */}
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="icon-bx-wraper black">
          <div className="icon-content ">
            <div className="icon-md text-primary m-b20">
              {/* <i className="ti-camera"></i> */}
              <img alt="DevOps Engineer Icon" src={icon7} />
            </div>
            <a href={jobUrl} className="dez-tilte">
              DevOps Engineer{" "}
            </a>
            <p className="m-a0">11 Jobs</p>
            {/* <div className="rotate-icon"><i className="ti-camera"></i></div>  */}
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="icon-bx-wraper navyblue">
          <div className="icon-content">
            <div className="icon-md text-primary m-b20">
              {/* <i className="ti-panel"></i> */}
              <img alt="Sr Angular Developer Icon" src={icon8} />
            </div>
            <a href={jobUrl} className="dez-tilte">
              Sr Angular Developer{" "}
            </a>
            <p className="m-a0">6 Jobs</p>
            {/* <div className="rotate-icon"><i className="ti-panel"></i></div>  */}
          </div>
        </div>
      </div>
      {/* <div className="col-lg-12 text-center m-t30">
                <button className="site-button radius-xl">All Categories</button>
            </div> */}
    </div>
  );
}

export default PopularJobsHome;
